"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMemoryForm = void 0;

var _immutable = require("immutable");

var _getInitialState = require("../reducer/getInitialState");

var _validateAll = require("../validate/validateAll");

var _resolveFieldData = require("../resolveFieldData");

var _getFieldValues = require("../helpers/getFieldValues");

var _pruneNonErrors = require("../validate/pruneNonErrors");

var createMemoryForm = function createMemoryForm(_ref) {
  var fields = _ref.fields,
      validate = _ref.validate,
      initialValues = _ref.initialValues;
  var fieldData;
  var formTools = {
    current: {}
  };

  var fakeDispatch = function fakeDispatch() {
    return undefined;
  };

  var getAllValues = function getAllValues() {
    return (0, _immutable.fromJS)((0, _getFieldValues.getFieldValues)(fieldData));
  };

  var state = (0, _getInitialState.getInitialState)(fields, initialValues, {}, formTools);
  fieldData = (0, _resolveFieldData.resolveFieldData)(state, fakeDispatch, getAllValues);

  var validateForm = function validateForm() {
    var errors = (0, _validateAll.validateAll)(state, fieldData, validate, getAllValues);
    errors = (0, _pruneNonErrors.pruneNonErrors)(errors);
    return {
      errors: errors,
      isValid: Object.keys(errors).length === 0
    };
  };

  return {
    validate: validateForm
  };
};

exports.createMemoryForm = createMemoryForm;